import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ITempProfileData {
  name: string;
  phone: string;
  email: string;
  birthDate: string;
  message: string;
  partner_id?: number | string;
}

export interface ITempProfilesState {
  tempProfilesData: { [profileId: string]: ITempProfileData };
}

const initialState: ITempProfilesState = {
  tempProfilesData: {},
};

const tempProfilesSlice = createSlice({
  name: "tempProfiles",
  initialState,
  reducers: {
    setTempProfileData(
      state,
      action: PayloadAction<{ profileId: string; profileData: ITempProfileData }>
    ) {
      const { profileId, profileData } = action.payload;
      state.tempProfilesData[profileId] = profileData;
    },
    updateTempProfileField(
      state,
      action: PayloadAction<{ profileId: string; field: keyof ITempProfileData; value: string }>
    ) {
      const { profileId, field, value } = action.payload;
      if (!state.tempProfilesData[profileId]) {
        state.tempProfilesData[profileId] = {
          name: "",
          phone: "",
          email: "",
          birthDate: "",
          message: "",
        };
      }
      state.tempProfilesData[profileId][field] = value;
    },
    clearTempProfilesData(state) {
      state.tempProfilesData = {};
    },
  },
});

export const { setTempProfileData, updateTempProfileField, clearTempProfilesData } =
  tempProfilesSlice.actions;

export default tempProfilesSlice.reducer;

